import {Service} from './service';
import {Partner} from './partner/partner';
import {Chat} from './chat';
import {Document} from './document';
import {ProjectContainer} from './project-container';
import {Observable} from 'rxjs';

// Todo: Actualizar o eliminar segun los verdaderos objetos de la BD

export interface Project {
  id: number;
  reference: string;
  name: string;
  startPlanDate?: string;
  endPlanDate?: string;
  chatId: number;
  operationExecutiveId?: number;
  deputyProjectManagerId?: number;
  administrationAgentId?: number;
  commercialExecutiveId?: number;
  operationsManagerId?: number;
  isActive: boolean;
  status: string
  priceId?: string; // Este es el ID de la cotizacion de Odoo (Revisar si es string o number al final)
  odooSaleOrderLineId?: number;
  odooSaleOrderOptionId?: number;
  partnerId?: number;
  services?: Service[];
  operationExecutive?: Partner;
  deputyProjectManager?: Partner;
  administrationAgent?: Partner;
  commercialExecutive?: Partner;
  operationsManager?: Partner;
  partner?: Partner;
  chat?: Chat;
  documents?: Document[];
  projectContainers?: ProjectContainer[];
  odooEntityId?: number;
  driveLink?: string;
}

export interface ProjectCreate {
  name: string;
  priceId?: number;
  partnerId?: number;
  operationExecutiveId?: number;
  deputyProjectManagerId?: number;
  administrationAgentId?: number;
  commercialExecutiveId?: number;
  operationsManagerId?: number;
  startPlanDate?: string;
  endPlanDate?: string;
  status?: string;
  reference?: string;
}

export interface ProjectServiceRequests {
  project: Observable<any>,
  projectDocuments: Observable<any>,
  containers: Observable<any>,
  service?: Observable<any>,
  serviceDocuments?: Observable<any>,
  template?: Observable<any>,
  flow?: Observable<any>,
}
